import { RootState } from '..';

export const selectSessionExpired = (state: RootState) =>
  state.apiSlice.isSessionExpired;

export const selectMaintenanceMode = (state: RootState) =>
  state.apiSlice.isMaintenance;
